import { Node } from '@tiptap/core'
import { sharedAttrs } from '../shared/shared-attrs'

// Unfilled placeholders from the template editor. Rendered as "[●]" since
// the placeholder was never populated with actual content.
export const Placeholder = Node.create({
  name: 'placeholder',

  group: 'inline',
  inline: true,
  content: 'text*',

  addAttributes() {
    return { ...this.parent?.(), ...sharedAttrs }
  },

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },
})
